import { useEffect, useState } from "react";
import { Col, Row, Table } from "react-bootstrap";
import logo from '../../assets/logo.png';
import api from '../../Components/Api/Api3';
import apiTx from '../../Components/Api/Api';
import Spinner from '../../Components/Spinner';
import './index.scss';
import { useSearchParams } from "react-router-dom";
const Painelconsultor = () => {
    const [filial, setFilial] = useState<any>('');
    const [searchParams] = useSearchParams();  
    const [ready, setReady] = useState(false);     
    const [ShowLoading, setShowLoading] = useState(false) 
    const [atualizar, setAtualizar] = useState(false) 
    const [mecanicaag, setMecanicaag] = useState([])
    const [mecanicatr, setMecanicatr] = useState([])
    const [alin_balanag, setAlin_balanag] = useState([])
    const [alin_balantr, setAlin_balantr] = useState([])
    const [atendentes, setAtendentes] = useState([])
    let timeout: NodeJS.Timeout;
    const COUNTDOWN_AMOUNT_TOTAL = 2 * 60; // 2 MINUTOS
    const [seconds, setSeconds] = useState<number>(COUNTDOWN_AMOUNT_TOTAL);
    const [showpainel, setShowpainel] = useState(false)
    const [showpin, setShowpin] = useState(false)
    const [pin, setPin] = useState('')
    const [gpin, setGpin] = useState('')
    const diaSemanaAtual = new Date().getDay();
    const credentials = btoa("RestAPI:siga@181"); 
    const headers = {
        'Content-Type': 'application/json;charset=UTF-8',
        "Access-Control-Allow-Origin": "*",
        "User-Agent": "PneusBrasil",
        "Accept": "application/json",
        'Authorization': `Basic ${credentials}`
    }
    const isFilial01 = (valor?: any) => {
        const filialInformada = String(valor ?? filial ?? '').trim();
        return filialInformada === '01' || filialInformada === '1';
    };
    const getApiPorFilial = (valor?: any) => (isFilial01(valor) ? apiTx : api);
    function getPin (cFilial: any) {
        setTimeout(() => {
        setShowLoading(true)    
        getApiPorFilial(cFilial).get('Getpin?filial='+cFilial,{headers})
        .then(response => {
            
            if (response.data.Pin.length > 0 ){  
                setGpin(response.data.Pin[0]["PIN"])                
                setShowLoading(false)
                if(pin === response.data.Pin[0]["PIN"] ){
                    setShowpainel(true);
                    setShowpin(true)
                }else{
                    alert('Pin invalido!')
                }                
                  //setInfoveuculo('Placa: ' + placa + ' Modelo: ' + response.data.Dadosveiculo[0]['modelo'] + ' Cor: ' + response.data.Dadosveiculo[0]['cor'])                     
            }else{
                  //setInfoveuculo('Placa não cadastrada!')
                setShowLoading(false)
            }                                   
        });
        }, 10 );       
    }; 
    function getOrdens (tpconsulta: string,cFilial: any) {
        setTimeout(() => {
        //setShowLoading(true)
        if(showpainel) {
            getApiPorFilial(cFilial).get('Painelconsultores?filial='+cFilial+'&tpconsulta='+tpconsulta+'&page=0&perpage=12',{headers})
            .then(response => {
                if (response.data.Ordens.length > 0 ){  
                    if(tpconsulta === '1'){
                        setMecanicaag(response.data.Ordens)
                    }else if (tpconsulta === '2'){
                        setMecanicatr(response.data.Ordens)                    
                    }else if (tpconsulta === '3'){
                        setAlin_balanag(response.data.Ordens)                    
                    }else if (tpconsulta === '4'){
                        setAlin_balantr(response.data.Ordens)                    
                    } 
                    
                    setAtualizar(true) 
                    setShowLoading(false)  
                    //setInfoveuculo('Placa: ' + placa + ' Modelo: ' + response.data.Dadosveiculo[0]['modelo'] + ' Cor: ' + response.data.Dadosveiculo[0]['cor'])                     
                }else{
                    //setInfoveuculo('Placa não cadastrada!')
                    setShowLoading(false)
                    setAtualizar(true)
                }                                   
            });
        }    
        }, 10 );        
    }; 
    function getAtendentes (cFilial: any) {
        setTimeout(() => {
        if(showpainel) {
            setShowLoading(true)
            getApiPorFilial(cFilial).get('Painelatendentes?filial='+cFilial+'&page=0&perpage=15',{headers})
            .then(response => {
                if (response.data.Atendentes.length > 0 ){  
                    setAtendentes(response.data.Atendentes)  
                    setAtualizar(true)               
                    setShowLoading(false)  
                      //setInfoveuculo('Placa: ' + placa + ' Modelo: ' + response.data.Dadosveiculo[0]['modelo'] + ' Cor: ' + response.data.Dadosveiculo[0]['cor'])                     
                }else{
                      //setInfoveuculo('Placa não cadastrada!')
                    setShowLoading(false)
                    setAtualizar(true)
                }                                   
            });
        }    
        }, 10 );        
    };   
    // const entrar = () => {
    //     let cP = ''
    //     cP = getPin('01')
    //     console.log(cP)
    //     if(pin === cP){
    //         setShowpainel(true);
    //         setShowpin(true)
    //     }else{
    //         alert('Pin invalido!')
    //     }
    // }      
    useEffect(() => {
        if (!ready) {
            setFilial(searchParams.get('filial'));
            let _filial = searchParams.get('filial');
            //console.log("filial: "+ searchParams.get('filial'))
            getOrdens('1',_filial)
            getOrdens('2',_filial)
            getOrdens('3',_filial)
            getOrdens('4',_filial)
            getAtendentes(_filial)            
            setReady(true);  
            //getPin('01')  
        }        
        if(!atualizar){
            getOrdens('1',filial)
            getOrdens('2',filial)
            getOrdens('3',filial)
            getOrdens('4',filial)
            getAtendentes(filial)
        }
        if(seconds > 0){
            timeout = setTimeout(() => {
                setSeconds((state) => state - 1);
            }, 1000);
        } else {
            clearTimeout(timeout);
            setSeconds(COUNTDOWN_AMOUNT_TOTAL)
            setAtualizar(false)
        } 
        const painel = document.querySelectorAll("div[id=divpainel]");  
        if (showpainel === true){
            painel[0].setAttribute('style', 'display:block');
        }else{
            painel[0].setAttribute('style', 'display:none');
        } 
        const pin = document.querySelectorAll("div[id=divpin]");  
        if (showpin === false){
            pin[0].setAttribute('style', 'display:block');
        }else{
            pin[0].setAttribute('style', 'display:none');
        }         
    },[seconds])         
    return (
        <>
            <div id="divpin" className="mt-4 ms-4">
                <label className="me-2">Digite o Pin</label>
                <input className="me-4" onChange={(e) => {setPin(e.target.value)}}></input>
                <button onClick={() => getPin('01')}>Entrar</button>
                <Spinner isLoading={ShowLoading} /> 
            </div>
            <div id="divpainel">          
            <Row className="flex-collum1">
                <Col className='w-25 d-flex justify-content-center'>
                    <img
                        src={logo}
                        className="logo"
                        alt="Car Center Pneus Brasil"
                    />                     
                </Col>
                <Col className='w-75 d-flex justify-content-start coll1-descri'>
                    <span className="fs-1 text-white font-weight-bold">Painel Consultores</span>                    
                </Col>
            </Row>  
            {/* Quadros dos serviços */}
            <Row>
                <Col className="col-10">
                    {/* Mecanica */}
                    <Row className="view-ports">
                        <Col className="border border-dark col-4">
                            <Row className="bg-secondary text-white title">
                                <Col className="d-flex justify-content-center align-items-center">
                                    <span>Veiculos</span>                                            
                                </Col>                               
                            </Row>                        
                            <Row className="bg-warning text-dark title">
                                <Col className="d-flex justify-content-center align-items-center">
                                    <span>Alinhamento/Balanceamento - Aguardando</span>                                            
                                </Col>                               
                            </Row>
                            <Row>
                                <Col>
                                    <Table striped bordered hover variant="light" responsive className='scrol'>
                                        <thead>
                                            <tr className='col-title'>      
                                            <th>Prisma</th>
                                            <th>Placa</th>
                                            <th>Veiculo</th>             
                                            </tr>
                                        </thead> 
                                        <tbody className=''> 
                                        {alin_balanag.map((list: any) => (           
                                        <tr key={list.id}>
                                            <td className="tdcurto">{list.p2}</td>
                                            <td className="tdcurto">{list.placa}</td>  
                                            <td className="tdcurto">{list.modelo}</td>                                   
                                        </tr>
                                        ))}                        
                                        </tbody>
                                    </Table>                                           
                                </Col>                                 
                            </Row>
                        </Col>
                        <Col className="border border-dark ">
                            <Row className="bg-secondary text-white title">
                                <Col className="d-flex justify-content-center align-items-center">
                                    <span>Atendentes</span>                                            
                                </Col>                               
                            </Row>                        
                            <Row className="bg-success text-white title">
                                <Col className="d-flex justify-content-center align-items-center">
                                    <span>Alinhamento/Balanceamento - Trabalhando</span>                                            
                                </Col>                               
                            </Row>
                            <Row>
                                <Col>
                                    <Table striped bordered hover variant="light" responsive className='scrol'>
                                        <thead>
                                            <tr className='col-title'>      
                                            <th>Prisma</th>
                                            <th>Placa</th>
                                            <th>Veiculo</th>  
                                            <th>Atendente</th>
                                            <th>Inicio</th>
                                            <th>Prev. Fim</th>
                                            <th>Status atual</th>           
                                            </tr>
                                        </thead> 
                                        <tbody className=''> 
                                        {alin_balantr.map((list: any) => (           
                                        <tr key={list.id}>
                                            <td className="tdcurto">{list.p2}</td>
                                            <td className="tdcurto">{list.placa}</td>
                                            <td className="tdcurto">{list.modelo}</td>
                                            <td className="tdcurto">{list.atendente}</td>
                                            <td className="tdcurto">{list.inicio}</td>
                                            <td className="tdcurto">{list.fim}</td>
                                            <td className="tdcurto">{list.status}</td>                                   
                                        </tr>
                                        ))}                        
                                        </tbody>
                                    </Table>                                           
                                </Col>                                 
                            </Row>           
                        </Col>                
                    </Row>
                    {/* Alinhamento/Balanceamento */}
                    <Row className="view-ports">
                    <Col className="border border-dark col-4"> 
                            <Row className="bg-warning text-dark title">
                                <Col className="d-flex justify-content-center align-items-center">
                                    <span>Mecanica - Aguardando</span>                                            
                                </Col>                               
                            </Row>
                            <Row>
                                <Col>
                                    <Table striped bordered hover variant="light" responsive className='scrol'>
                                        <thead>
                                            <tr className='col-title'>      
                                            <th>Prisma</th>
                                            <th>Placa</th>
                                            <th>Veiculo</th>             
                                            </tr>
                                        </thead> 
                                        <tbody className=''> 
                                        {mecanicaag.map((list: any) => (           
                                        <tr key={list.id}>
                                            <td className="tdcurto">{list.p1}</td>
                                            <td className="tdcurto">{list.placa}</td>    
                                            <td className="tdcurto">{list.modelo}</td>                                
                                        </tr>
                                        ))}                        
                                        </tbody>
                                    </Table>                                           
                                </Col>                                 
                            </Row>                                          
                        </Col>
                        <Col className="border border-dark">  
                        <Row className="bg-success text-white title">
                                <Col className="d-flex justify-content-center align-items-center">
                                    <span>Mecanica - Trabalhando</span>                                            
                                </Col>                               
                            </Row>
                            <Row>
                                <Col>
                                    <Table striped bordered hover variant="light" responsive className='scrol'>
                                        <thead>
                                            <tr className='col-title'>      
                                            <th>Prisma</th>
                                            <th>Placa</th>
                                            <th>Veiculo</th>  
                                            <th>Atendente</th>
                                            <th>Inicio</th>
                                            <th>Prev. Fim</th>         
                                            </tr>
                                        </thead> 
                                        <tbody className=''> 
                                        {mecanicatr.map((list: any) => (           
                                        <tr key={list.id}>
                                            <td className="tdcurto">{list.p1}</td>
                                            <td className="tdcurto">{list.placa}</td>
                                            <td className="tdcurto">{list.modelo}</td>
                                            <td className="tdcurto">{list.atendente}</td>
                                            <td className="tdcurto">{list.inicio}</td>
                                            <td className="tdcurto">{list.fim}</td>                                   
                                        </tr>
                                        ))}                        
                                        </tbody>
                                    </Table>                                           
                                </Col>                                 
                            </Row>           
                        </Col>               
                    </Row>                                                               
                </Col>
                {/* Atendentes Ultima ação */}
                <Col className="border border-dark">
                <Row className="bg-danger text-white title">
                                <Col className="d-flex justify-content-center align-items-center">
                                    <span>Atendentes</span>                                            
                                </Col>                               
                            </Row>
                            <Row>
                                <Col>
                                    <Table striped bordered hover variant="light" responsive className='scrol'>
                                        <thead>
                                            <tr className='col-title'>      
                                            <th>Atendente</th>
                                            <th>Ult. Ação</th>
                                            </tr>
                                        </thead> 
                                        <tbody className=''> 
                                        {atendentes.map((list: any) => (           
                                        <tr key={list.id}>
                                            <td className="tdcurto">{list.atendente}</td>
                                            <td className="tdcurto">{list.hora}</td>                                  
                                        </tr>
                                        ))}                        
                                        </tbody>
                                    </Table>                                           
                                </Col>                                 
                            </Row> 
                </Col>
            </Row>  
            <div className='foot'>
                <span>{seconds}</span>
                <Spinner isLoading={ShowLoading} /> 
            </div>
        </div>                     
        </>
    )
};

export default Painelconsultor;
